<template>
  <div
    :class="{ 'user-card': true, 'user-card-active': isPressing }"
    @touchstart="handleTouchStart"
    @touchend="handleTouchEnd"
    @click="handleClick"
  >
    <div class="user-type">
      <div class="user-type-name">{{ userTypeInfo.name }}</div>
      <div class="user-type-description">{{ userTypeInfo.description }}</div>
    </div>
    <img class="user-img" :src="userTypeInfo.img" />
  </div>
</template>

<script>
import engineerImg from '@assets/images/user_type_engineer@3x.png';
import userImg from '@assets/images/user_type_user@3x.png';
import store from '@stores';

export default _extend({
  name: 'UserCard',
  props: {
    // 用户类型
    userType: {
      type: String
    }
  },
  data() {
    return {
      isPressing: false
    };
  },
  methods: {
    handleTouchStart() {
      this.isPressing = true;
    },
    handleTouchEnd() {
      this.isPressing = false;
    },
    handleClick() {
      this.$store.commit(store.VX_TYPES.FORM.CLEAR_DATA);
      setTimeout(() => {
        const searchWithoutUserType = window.location.search.replace(
          /userType=[^&]+&?/,
          ''
        );
        this.$router.push(
          `${this.userTypeInfo.jumpPath}${searchWithoutUserType}&userType=${
            this.userType
          }`
        );
      }, 0);
    }
  },
  computed: {
    userTypeInfo() {
      const USER_TYPE_INFO_ENUM = {
        user: {
          name: '用户',
          description: '自助激活',
          img: userImg,
          jumpPath: '/v2/ActiveForm'
        },
        engineer: {
          name: '安装人员',
          description: '上门激活',
          img: engineerImg,
          jumpPath: '/v2/InstallCode/'
        }
      };
      return USER_TYPE_INFO_ENUM[this.userType];
    }
  }
});
</script>

<style lang="scss">
@import './UserCard';
</style>



// WEBPACK FOOTER //
// src/business/views/UserRole/UserCard/UserCard.vue